import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84893136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-box" }
const _hoisted_2 = ["onClick", "src"]
const _hoisted_3 = ["onClick", "src"]

import { ImagePreview } from 'vant';
import type { PropType } from 'vue';
import config from '@/_config';
import { imgUrl } from '@/lib';


export default /*#__PURE__*/_defineComponent({
  props: {
  picUrl: {
    type: Array as PropType<string[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props



const showImgClick = (imgindex: number, arr: string[]) => {
  arr = arr.map(item => item.indexOf('http') !== -1 ? item : `${config.imgBaseURL}${item}`);
  ImagePreview({
    images: arr,
    startPosition: imgindex,
    closeable: true,
    closeOnPopstate: true
  });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.picUrl.length == 1)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.picUrl, (item, imgindex) => {
          return (_openBlock(), _createElementBlock("img", {
            onClick: _withModifiers(($event: any) => (showImgClick(imgindex, props.picUrl)), ["stop"]),
            src: _unref(imgUrl)(item),
            class: "comment-img",
            style: {"width":"300px","height":"auto","max-height":"600px"},
            key: imgindex
          }, null, 8, _hoisted_2))
        }), 128))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.picUrl, (item, imgindex) => {
          return (_openBlock(), _createElementBlock("img", {
            onClick: _withModifiers(($event: any) => (showImgClick(imgindex, props.picUrl)), ["stop"]),
            src: _unref(imgUrl)(item),
            class: "comment-img",
            key: imgindex
          }, null, 8, _hoisted_3))
        }), 128))
  ]))
}
}

})